<template>
  <div class="mapboxgl-custom-timeline">
    <v-card>
      <v-card-text style="padding-right: 25px">
        <p class="body-1 mb-0">China’s Gross Regional Product (GRP) and Total Population of major cities.</p>

        <!-- the player -->
        <div class="timeline-player">
          <v-slider
            hide-details
            v-model="this.currentYear"
            :tick-labels="ticksLabels"
            :max="2016"
            :min="2011"
            step="1"
            ticks="always"
            tick-size="2"
            :prepend-icon="tickIcon"
            @click:prepend="playTimeline" />
        </div>

        <i>Data taken from: National Bureau of Statistics of China</i>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimelinePlayer',
  data() {
    return {
      time: 2011,
      ticksLabels: [2012, 2013, 2014, 2015, 2016],
      tickIcon: 'play_arrow',
      timelineId: null,
    };
  },
  computed: {
    ...mapGetters('viewTimeline', ['currentYear']),
  },
  methods: {
    playTimeline() {
      // set playing state
      this.tickIcon = this.tickIcon === 'play_arrow' ? 'stop' : 'play_arrow';

      if (this.tickIcon === 'stop') {
        // reset current year
        this.$store.dispatch('viewTimeline/resetYear');

        // start playing timeline
        this.timelineId = setInterval(() => {
          // update current year
          this.$store.dispatch('viewTimeline/updateYear');

          if (this.currentYear === 2016) {
            this.tickIcon = 'play_arrow';

            clearInterval(this.timelineId);
          }
        }, 2000);
      } else {
        // stops playing and reset
        clearInterval(this.timelineId);
        // reset current year
        this.$store.dispatch('viewTimeline/resetYear');
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.timeline-player {
  >>> .v-input__control {
    pointer-events: none;
  }

  .v-input--slider {
    margin-top: 8px;
  }
}
</style>
